/* eslint-disable line-comment-position */
import { queryOptions, useQuery, useInfiniteQuery } from '@tanstack/react-query';

import { getLegalCases, getLegalCasesV2 } from '#services/LegalCaseService';

export const LEGAL_CASES_QUERY_KEY = 'legalCases';

const DEFAULT_LIST_LIMIT = 20;

export const legalCasesQueryOptions = (params = {}) =>
  queryOptions({
    queryKey: [LEGAL_CASES_QUERY_KEY, params],
    queryFn: async () => {
      const response = await getLegalCases(params);
      return response?.data?.result || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000 // 10 minutos
  });

export function useLegalCases(params = {}) {
  return useQuery(legalCasesQueryOptions(params));
}

const buildLegalCasesInfiniteConfig = (filters = {}, options = {}) => {
  const { limit = DEFAULT_LIST_LIMIT, ...listFilters } = filters;

  return queryOptions({
    queryKey: [LEGAL_CASES_QUERY_KEY, 'infinite', { ...listFilters, limit }],
    queryFn: ({ pageParam = 1 }) =>
      getLegalCasesV2({
        ...listFilters,
        page: pageParam,
        limit
      }),
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const { pagination } = lastPage;
      return pagination?.hasNextPage ? pagination.currentPage + 1 : undefined;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options
  });
};

export function useInfiniteLegalCases(filters, options) {
  return useInfiniteQuery(buildLegalCasesInfiniteConfig(filters, options));
}

const buildLegalCasesPaginatedConfig = (filters = {}, options = {}) => {
  const { limit = DEFAULT_LIST_LIMIT, page = 1, ...listFilters } = filters;
  return queryOptions({
    queryKey: [LEGAL_CASES_QUERY_KEY, 'paginated', { ...listFilters, limit, page }],
    queryFn: () => getLegalCasesV2({ ...listFilters, page, limit }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options
  });
};

export function usePaginatedLegalCases(filters, options) {
  return useQuery(buildLegalCasesPaginatedConfig(filters, options));
}
